// extracted by mini-css-extract-plugin
export default {"base":"Menu_base__o2UGy","open":"Menu_open__wE18i"};